import { FC } from 'react';
import { CaretPosition } from '../../components/Button/Button.types';
import { Breadcrumb, EditFormHeader, Title, TitleWithBreadcrumbContainer } from "./EditForm.styles";

export interface HeaderProps {
  breadcrumb: BreadcrumbProps;
  title?: string;
}

export interface BreadcrumbProps {
  to: string;
  label: string;
  onClick?: () => void;
}

const Header: FC<HeaderProps> = (
    {
      breadcrumb,
      title
    }
) => {
  return (
      <EditFormHeader>
        <TitleWithBreadcrumbContainer>
          <Breadcrumb
              to={breadcrumb.to}
              caret={CaretPosition.Left}
              label={breadcrumb.label}
              onClick={breadcrumb.onClick}
          />
          {title && <Title>{title}</Title>}
        </TitleWithBreadcrumbContainer>
      </EditFormHeader>
  );
};

export default Header;
